import React, { useEffect, useState } from "react";
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faUserTie, faCirclePause } from '@fortawesome/free-solid-svg-icons';
import NewAdminModal from "components/Private/NewAdminModal";
import EditAdminModal from "components/Private/EditAdminModal";
import Swal from 'sweetalert2';
import { useGuestContext } from '../../contexts/GuestContext';
// react-bootstrap components
import {
    Modal,
    Button,
    Card,
    Nav,
    Container,
    Dropdown,
    Row,
    Col,
    OverlayTrigger, Tooltip
} from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import SheetUpload from "components/Private/SheetUpload";
import { Scrollbars } from 'react-custom-scrollbars';
// core components
import ReactTable from "../../components/ReactTable/ReactTable";

function AdminUserMgmt() {

    const [refreshDataTrigger, setRefreshDataTrigger] = useState(0);
    const { language, setPageBanner, setLoading } = useGuestContext();
    const [modal, setModal] = React.useState(false);
    const [editModal, setEditModal] = React.useState(false);
    const [uploadModal, setUploadModal] = React.useState(false);
    const [alert, setAlert] = React.useState(null);
    const [registrations, setRegistrations] = useState([]); // state for holding fetched data

    const [selectedRegistration, setSelectedRegistration] = useState(null);

    const handleEditClick = (admin) => {
        setSelectedRegistration(admin);
        setEditModal(true);
    };


    const hideAlert = () => {
        setAlert(null);
    };




    const handleDeleteClick = (guestId) => {
        const htmlContent = language === "English" ?
            `Are you sure you would like to delete the registration of <strong style="color: #007bff;">Guest ID: ${guestId}</strong>?` :
            `您確定要刪除 <strong style="color: #007bff;">Guest ID：${guestId}</strong> 的報名嗎？`;

        Swal.fire({
            title: language === "English" ? "Delete Confirmation" : "確認要刪除嗎？",
            html: htmlContent,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: language === "English" ? "Confirm Deletion" : "確認刪除管理員",
            cancelButtonText: language === "English" ? "Cancel" : "取消"
        }).then((result) => {
            if (result.isConfirmed) {
                deleteRegistration(guestId);
            } else {
                hideAlert();
            }
        });
    };

    const successDelete = (guestId) => {
        const htmlContent = language === "English" ?
            `The registration of <strong style="color: #007bff;">Guest ID: ${guestId}</strong> is deleted.` :
            `管理員 (ID：${guestId}) 已被刪除。`;

        Swal.fire({
            title: "Deleted!",
            html: htmlContent,
            icon: 'success',
            confirmButtonColor: '#17a2b8', // Using a color for the confirm button (Bootstrap's info color)
            confirmButtonText: language === "English" ? "OK" : "好的"
        }).then(() => {
            hideAlert();
        });
    };

    const deleteRegistration = async (guestId) => {
        try {
            setLoading(true); // Start loading (if you have a loading state)
            await axios.delete(`${process.env.REACT_APP_SERVER_URL}/admin/users/${guestId}`, { withCredentials: true });
            successDelete(guestId);
            setLoading(false); // Stop loading (if you have a loading state)
            setRefreshDataTrigger(prev => prev + 1);
        } catch (error) {
            console.error('Error deleting registration:', error);
            setLoading(false); // Stop loading (if you have a loading state)
            const detail = error.response?.data?.detail || "Delete failed.";
            Swal.fire({
                title: "Error!",
                text: detail,
                icon: "error"
            });
        }
    }

    const handleSuspendClick = (admin) => {
        const action = admin.isSuspended ? "Unsuspend" : "Suspend";
        const actionZh = admin.isSuspended ? "恢复" : "暂停";
        
        const htmlContent = language === "English" ?
            `Are you sure you would like to ${action.toLowerCase()} <strong style="color: #007bff;">Admin: ${admin.name}</strong>?` :
            `您確定要${actionZh} <strong style="color: #007bff;">管理員：${admin.name}</strong> 嗎？`;

        Swal.fire({
            title: language === "English" ? `${action} Confirmation` : "確認操作？",
            html: htmlContent,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: language === "English" ? `Confirm ${action}` : `確認${actionZh}`,
            cancelButtonText: language === "English" ? "Cancel" : "取消"
        }).then((result) => {
            if (result.isConfirmed) {
                suspendRegistration(admin);
            }
        });
    };

    const suspendRegistration = async (admin) => {
        try {
            setLoading(true);
            await axios.put(`${process.env.REACT_APP_SERVER_URL}/admin/users/${admin.id}/suspend?suspend=${!admin.isSuspended}`, null, { withCredentials: true });
            setLoading(false);
            setRefreshDataTrigger(prev => prev + 1);
            Swal.fire({
                title: "Success",
                text: language === "English" ? `Admin ${admin.isSuspended ? 'unsuspended' : 'suspended'} successfully.` : `管理員已成功${admin.isSuspended ? '恢复' : '暂停'}。`,
                icon: 'success'
            });
        } catch (error) {
            console.error('Error suspending registration:', error);
            setLoading(false);
            const detail = error.response?.data?.detail || "Action failed.";
            Swal.fire({
                title: "Error!",
                text: detail,
                icon: "error"
            });
        }
    };

    useEffect(() => {
        const fetchRegistrations = async () => {
            try {
                setLoading(true); // If you have a loading state
                const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/admin/users`, { withCredentials: true });
                const formattedData = response.data.map((admin, index) => ({
                    id: admin.id,
                    displayname: admin.displayname || "-",
                    name: `${admin.firstname || ''} ${admin.lastname || ''}`.trim() || "-",
                    email: admin.email || "-",
                    phone: admin.phone || "-",
                    status: admin.isSuspended ? "Suspended" : "Active",
                    actions: (
                        <div className="actions-right">
                            {/* Edit admin */}
                            <Button
                                onClick={() => handleEditClick(admin)}
                                size="sm"
                                className="text-success btn-link edit"
                            >
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id={`tooltip`}>
                                            Edit Administrator
                                        </Tooltip>
                                    }
                                >
                                    <i className="fa fa-edit" />
                                </OverlayTrigger>
                            </Button>{" "}
                            {/* Suspend admin */}
                            <Button
                                size="sm"
                                className="text-warning btn-link like"
                                disabled={admin.role === "superadmin"}
                                onClick={() => handleSuspendClick(admin)}
                            >
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id={`tooltip`}>
                                            {admin.isSuspended ? "Unsuspend this Administrator" : "Suspend this Administrator"}
                                        </Tooltip>
                                    }
                                >
                                    <FontAwesomeIcon icon={faCirclePause} />
                                </OverlayTrigger>

                            </Button>{" "}
                            {/* Delete admin */}
                            <Button
                                variant="danger"
                                size="sm"
                                className="btn-link remove text-danger"
                                disabled={admin.role === "superadmin"}
                                onClick={() => handleDeleteClick(admin.id)}
                            >
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id={`tooltip`}>
                                            Delete Administrator
                                        </Tooltip>
                                    }
                                >
                                    <i className="fa fa-times" />
                                </OverlayTrigger>
                            </Button>{" "}
                        </div>
                    )
                }));
                setRegistrations(formattedData);
                setLoading(false); // If you have a loading state
            } catch (error) {
                console.error('Error fetching registration data:', error);
                setLoading(false); // If you have a loading state
            }
        };
        fetchRegistrations();
        console.log(registrations)
    }, [refreshDataTrigger]);

    const dropdownContent = (
        <>
            <Dropdown as={Nav.Item}>
                <Dropdown.Toggle as={Button} variant="info" className="btn-wd mr-1 btn-outline font-weight-bold" id="regPageAction">
                    Actions
                    <span className="dropdown-arrow ml-2">
                        <i className="nc-icon nc-minimal-down"></i>
                    </span>
                </Dropdown.Toggle>
                <Dropdown.Menu alignRight aria-labelledby="navbarDropdownMenuLink">
                    <Dropdown.Item className="text-default" href="#pablo" onClick={e=>{ e.preventDefault(); setModal(true); }}>
                    <i className="nc-icon nc-satisfied"></i>
                         添加管理員
                    </Dropdown.Item>
                    <Dropdown.Item className="text-default" href="#pablo" onClick={e=>e.preventDefault()}>
                        <i className="nc-icon nc-cloud-download-93"></i>
                        下載信息
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
    return (
        <>
            {alert}
            {/* {alertState} */}
            <Container fluid>
                <Row>
                    <Col md="12">
                        <Card>
                            <Card.Header>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h4 className="title font-weight-bold">管理員列表</h4>
                                    {dropdownContent}
                                </div>
                            </Card.Header>
                            <hr />
                            <Card.Body >
                                {/* <Scrollbars style={{ width: '80%', height: 1000}}> */}
                                <ReactTable
                                    data={registrations}
                                    columns={[
                                        {
                                            Header: "Display Name",
                                            accessor: "displayname",
                                        },
                                        {
                                            Header: "Full Name",
                                            accessor: "name",
                                        },
                                        {
                                            Header: "Email",
                                            accessor: "email",
                                        },
                                        {
                                            Header: "Phone",
                                            accessor: "phone",
                                        },
                                        {
                                            Header: "Status",
                                            accessor: "status",
                                        },
                                        {
                                            Header: "Actions",
                                            accessor: "actions",
                                            sortable: false,
                                            filterable: false,
                                        },
                                    ]}
                                    /*
                                      You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                                    */
                                    className="-striped -highlight primary-pagination"
                                />
                                {/* </Scrollbars> */}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <NewAdminModal modal={modal} setModal={setModal} refreshData={() => setRefreshDataTrigger(prev => prev + 1)} />
            <EditAdminModal modal={editModal} setModal={setEditModal} refreshData={() => setRefreshDataTrigger(prev => prev + 1)} adminData={selectedRegistration} />
        </>
    );
}
export default AdminUserMgmt;
